import React from 'react'

import GreenBasket from 'assets/svg/Cesta_green.svg'

import Modal from 'components/Modal'
import Button from 'components/Button'

import './ModalReatriveError.scss'

const ModalReatriveError = (props) => {
    return (
        <Modal
            className="reatrive-modal"
            open={true}
            closeBtn={true}
            onClick={props.onClick}
        >
            <div className="reatrive-modal__header">
                <img className="icon" src={GreenBasket} alt="Cesta Alelo" />
            </div>
            <div className="reatrive-modal__title">
                <span>
                    <strong>OPS!</strong> Infelizmente não conseguimos recuperar
                    a sua cesta :(
                </span>
            </div>
            <div className="reatrive-modal__description">
                <span>
                    {' '}
                    Mas não tem problema, você pode contratar os produtos Alelo
                    clicando no botão abaixo.
                </span>
            </div>
            <Button kind="reload" type="button" onClick={props.onClick}>
                CONTINUAR
            </Button>
        </Modal>
    )
}

export default ModalReatriveError
